<div mat-dialog-content>
  <div class="mat-dialog-header">
    <h3>Prescrição Não Padronizada</h3>
  </div>

  <form class="form" [formGroup]="model" (ngSubmit)="onSubmit()">
    <div class="mat-dialog-content">
      <div class="row">

        @if (listTextTemplate && listTextTemplate.length > 0) {
        <div class="col-12 col-sm-6 col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>Templates</mat-label>
            <mat-select>
              <mat-option [value]="null" (click)="selectTemplateToDescription(null)">Selecione...</mat-option>
              @for (item of listTextTemplate; track item) {
              <mat-option (click)="selectTemplateToDescription(item)" [value]="item">
                {{item.textTemplateName}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <div class="quill-content col-12 col-sm-12 col-md-12">
          <quill-editor class="quill-input" [modules]="quillConfiguration" formControlName="formattedText"
            [placeholder]="'Prescrição não padronizada'"
            [styles]="{'max-height': '300px', 'min-height': '150px', 'overflow': 'auto'}" [debounceTime]="0">
          </quill-editor>
        </div>

      </div>
      <div class="footer-panel-modal-list">
        <div class="row">
          @if (!this.data.readOnly) {
          <div class="col-6">
            <a mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">Cancelar</a>
          </div>
          }
          @if (!this.data.readOnly) {
          <div class="col-6">
            <button mat-flat-button type="submit" color="primary" class=" btn-block">
              <span>Salvar</span>
            </button>
          </div>
          }
          <div class="col-12">
            @if (this.data.readOnly) {
            <a mat-flat-button color="primary" class="btn-block" (click)="clickCancel()">Ok</a>
            }
          </div>
        </div>
      </div>
    </div>
  </form>
</div>